// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .rightBar {
  flex: 3 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: #f6f3f3;
}
@media (max-width: 480px) {
  .theme-light .rightBar {
    display: none;
  }
}
@media (max-width: 960px) {
  .theme-light .rightBar {
    display: none;
  }
}
.theme-light .rightBar::-webkit-scrollbar {
  display: none;
}
.theme-light .rightBar .container {
  padding: 20px;
}
.theme-light .rightBar .container .item {
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);
  padding: 20px;
  margin-bottom: 20px;
  background-color: white;
}
.theme-light .rightBar .container .item span {
  color: gray;
}
.theme-light .rightBar .container .item .target {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.theme-light .rightBar .container .item .target .targetInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.theme-light .rightBar .container .item .target .targetInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .rightBar .container .item .target .targetInfo .online {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: limegreen;
  position: absolute;
  top: 0;
  left: 30px;
}
.theme-light .rightBar .container .item .target .targetInfo p {
  color: #555;
}
.theme-light .rightBar .container .item .target .targetInfo span {
  font-weight: 500;
  color: #000;
}
.theme-light .rightBar .container .item .target .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-light .rightBar .container .item .target .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-light .rightBar .container .item .target .buttons button:first-child {
  background-color: #5271ff;
}
.theme-light .rightBar .container .item .target .buttons button:last-child {
  background-color: #f0544f;
}
.theme-light .rightBar .container .item .user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.theme-light .rightBar .container .item .user .userInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.theme-light .rightBar .container .item .user .userInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .rightBar .container .item .user .userInfo .online {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: limegreen;
  position: absolute;
  top: 0;
  left: 30px;
}
.theme-light .rightBar .container .item .user .userInfo p {
  color: #555;
}
.theme-light .rightBar .container .item .user .userInfo span {
  font-weight: 500;
  color: #000;
}
.theme-light .rightBar .container .item .user .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-light .rightBar .container .item .user .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-light .rightBar .container .item .user .buttons button:first-child {
  background-color: #5271ff;
}
.theme-light .rightBar .container .item .user .buttons button:last-child {
  background-color: #f0544f;
}
.theme-dark .rightBar {
  flex: 3 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: #333;
}
@media (max-width: 480px) {
  .theme-dark .rightBar {
    display: none;
  }
}
@media (max-width: 960px) {
  .theme-dark .rightBar {
    display: none;
  }
}
.theme-dark .rightBar::-webkit-scrollbar {
  display: none;
}
.theme-dark .rightBar .container {
  padding: 20px;
}
.theme-dark .rightBar .container .item {
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);
  padding: 20px;
  margin-bottom: 20px;
  background-color: #222;
}
.theme-dark .rightBar .container .item span {
  color: gray;
}
.theme-dark .rightBar .container .item .target {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.theme-dark .rightBar .container .item .target .targetInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.theme-dark .rightBar .container .item .target .targetInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .rightBar .container .item .target .targetInfo .online {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: limegreen;
  position: absolute;
  top: 0;
  left: 30px;
}
.theme-dark .rightBar .container .item .target .targetInfo p {
  color: #d1d0c9;
}
.theme-dark .rightBar .container .item .target .targetInfo span {
  font-weight: 500;
  color: #fffef9;
}
.theme-dark .rightBar .container .item .target .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-dark .rightBar .container .item .target .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-dark .rightBar .container .item .target .buttons button:first-child {
  background-color: #5271ff;
}
.theme-dark .rightBar .container .item .target .buttons button:last-child {
  background-color: #f0544f;
}
.theme-dark .rightBar .container .item .user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.theme-dark .rightBar .container .item .user .userInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.theme-dark .rightBar .container .item .user .userInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .rightBar .container .item .user .userInfo .online {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: limegreen;
  position: absolute;
  top: 0;
  left: 30px;
}
.theme-dark .rightBar .container .item .user .userInfo p {
  color: #d1d0c9;
}
.theme-dark .rightBar .container .item .user .userInfo span {
  font-weight: 500;
  color: #fffef9;
}
.theme-dark .rightBar .container .item .user .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-dark .rightBar .container .item .user .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-dark .rightBar .container .item .user .buttons button:first-child {
  background-color: #5271ff;
}
.theme-dark .rightBar .container .item .user .buttons button:last-child {
  background-color: #f0544f;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/rightBar/rightBar.scss"],"names":[],"mappings":"AAqBI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;AAFJ;ADoCE;EAtBE;ICTE,aAAA;EADJ;AACF;ADoCE;EA3BE;ICNE,aAAA;EACJ;AACF;AACI;EACE,aAAA;AACN;AAEI;EACE,aAAA;AAAN;AAEM;EAGE,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,WAAA;AAAV;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AADV;AAGU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AADZ;AAEY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAAd;AAGY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AADd;AAIY;EACE,WAAA;AAFd;AAKY;EACE,gBAAA;EACA,WAAA;AAHd;AAOU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AALZ;AAOY;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AALd;AAOc;EACE,yBAAA;AALhB;AAQc;EACE,yBAAA;AANhB;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAVV;AAYU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAVZ;AAWY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AATd;AAYY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAVd;AAaY;EACE,WAAA;AAXd;AAcY;EACE,gBAAA;EACA,WAAA;AAZd;AAgBU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAdZ;AAgBY;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAdd;AAgBc;EACE,yBAAA;AAdhB;AAiBc;EACE,yBAAA;AAfhB;ADvHI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;AA2IJ;ADzGE;EAtBE;ICTE,aAAA;EA4IJ;AACF;ADzGE;EA3BE;ICNE,aAAA;EA8IJ;AACF;AA5II;EACE,aAAA;AA8IN;AA3II;EACE,aAAA;AA6IN;AA3IM;EAGE,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AA6IR;AA3IQ;EACE,WAAA;AA6IV;AA1IQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AA4IV;AA1IU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA4IZ;AA3IY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA6Id;AA1IY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AA4Id;AAzIY;EACE,cAAA;AA2Id;AAxIY;EACE,gBAAA;EACA,cAAA;AA0Id;AAtIU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAwIZ;AAtIY;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAwId;AAtIc;EACE,yBAAA;AAwIhB;AArIc;EACE,yBAAA;AAuIhB;AAjIQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAmIV;AAjIU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAmIZ;AAlIY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAoId;AAjIY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AAmId;AAhIY;EACE,cAAA;AAkId;AA/HY;EACE,gBAAA;EACA,cAAA;AAiId;AA7HU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA+HZ;AA7HY;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA+Hd;AA7Hc;EACE,yBAAA;AA+HhB;AA5Hc;EACE,yBAAA;AA8HhB","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.rightBar {\n  @include themify($themes) {\n    flex: 3;\n    position: sticky;\n    top: 70px;\n    height: calc(100vh - 70px);\n    overflow: scroll;\n    background-color: themed(\"bgSoft\");\n\n    @include mobile{\n      display: none;\n    }\n    @include tablet{\n      display: none;\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .container {\n      padding: 20px;\n\n      .item {\n        -webkit-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n        -moz-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n        box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n        padding: 20px;\n        margin-bottom: 20px;\n        background-color: themed(\"bg\");\n\n        span {\n          color: gray;\n        }\n\n        .target {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin: 20px 0px;\n\n          .targetInfo {\n            display: flex;\n            align-items: center;\n            gap: 20px;\n            position: relative;\n            flex-wrap: wrap;\n            img {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n\n            .online {\n              width: 12px;\n              height: 12px;\n              border-radius: 50%;\n              background-color: limegreen;\n              position: absolute;\n              top: 0;\n              left: 30px;\n            }\n\n            p {\n              color: themed(\"textColorSoft\");\n            }\n\n            span {\n              font-weight: 500;\n              color: themed(\"textColor\");\n            }\n          }\n\n          .buttons {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            flex-wrap: wrap;\n\n            button {\n              border: none;\n              padding: 5px;\n              color: white;\n              cursor: pointer;\n\n              &:first-child {\n                background-color: #5271ff;\n              }\n\n              &:last-child {\n                background-color: #f0544f;\n              }\n            }\n          }\n        }\n\n        .user {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin: 20px 0px;\n\n          .userInfo {\n            display: flex;\n            align-items: center;\n            gap: 20px;\n            position: relative;\n            flex-wrap: wrap;\n            img {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n\n            .online {\n              width: 12px;\n              height: 12px;\n              border-radius: 50%;\n              background-color: limegreen;\n              position: absolute;\n              top: 0;\n              left: 30px;\n            }\n\n            p {\n              color: themed(\"textColorSoft\");\n            }\n\n            span {\n              font-weight: 500;\n              color: themed(\"textColor\");\n            }\n          }\n\n          .buttons {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            flex-wrap: wrap;\n\n            button {\n              border: none;\n              padding: 5px;\n              color: white;\n              cursor: pointer;\n\n              &:first-child {\n                background-color: #5271ff;\n              }\n\n              &:last-child {\n                background-color: #f0544f;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
